import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/background/background.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/nav.tsx")